// These auxiliaries are filtered from the beginning of word combinations in the prominent words.
export const filteredAuxiliaries =  [
	"byť",
	"som",
	"si",
	"je",
	"sme",
	"ste",
	"sú",
	"bol",
	"bola",
	"boli",
	"bolo",
	"budem",
	"budeš",
	"bude",
	"budeme",
	"budete",
	"budú",
];

export default filteredAuxiliaries;
